export default __webpack_public_path__ + "static/media/6.035b9e09.png";